import { createApp } from 'vue';
import TtfToWoff2Converter from '@/Components/TtfToWoff2Converter.vue';
import '@styles/app.css';

createApp(TtfToWoff2Converter).mount('#ttf-to-woff2-converter');
